module.exports = __webpack_public_path__ + "static/media/search.6c9017a2.svg";